import styles from './index.module.scss'
import {useContext} from 'react'
import { PageContext } from '../../../../context/PageContextProvider';

const GeneralInput = props => {
   const { language } = useContext(PageContext);
   const require = {
      "AZ": "Tələb olunmur",
      "ENG" : "Not required",
      "RU" : "Не требуется"
   }
   return (
      <label className={styles.container}>
         {props.label&&props.label}
         {props.require&&<span>{require[language]}</span>}
         <input {...props} />
      </label>
   )
}

export default GeneralInput